import { render, staticRenderFns } from "./SelectCustomerGroup.vue?vue&type=template&id=490d05dc&"
import script from "./SelectCustomerGroup.vue?vue&type=script&lang=js&"
export * from "./SelectCustomerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports